import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { Divider } from '@material-ui/core';
import TaskList from "./KRIReportingTask";
import TaskDialog from "./TaskDialog";
import DuplicateTxnTable from "./KRIReportingDetailTable";
//tabs related import
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
//import RoutineDescriptionTable from "./RoutineDescriptionTable";
import config from "../../config/config";
import axios from 'axios';
import { styles } from '../CSS/Styles'

class RecipeReviewCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            queryID:"",
            expanded: false,
            actionView: false,
            chips: [],
            open: false,
            assignmentOpen: false,
            taskDialogOpen: false,
            //defaultTab
            value: 0,
            reason: 0,
            closureComment: "",
            approvalComment: "",
            assignComment:"",
            assignedUserName:"",
            valueReason: 0,
            //alert information
            metaData: {
                routine: " PO",
                alert_ID: "",
                entity: "",
                owner_id: "",
                owner_name: "",
                status: "",
                created_date: "",
                outstanding_task_count: 0,
                name:""
            },
            //transaction related
            fields: [],
            data: [],
            // logs data
            logsfields: [
                "id",
                "action",
                "action summary",
                "action user",
                "time stamp"
            ],
            logsdata: [],
            tasksdata: [],
            kri: {}


        };
        this.getRiskDetail = this.getRiskDetail.bind(this);


    }
    componentDidMount() {
        this.setState({ queryID:this.props.queryID });
        this.getRiskDetail();

        this.getAssignee();
        this.setState({data:[]});

    }
    componentDidUpdate(prevProps) {
        // console.log("new id : " + this.props.queryID + "vs old id : " + prevProps.queryID);
        if (this.props.riskname !== prevProps.riskname) {
            console.log("queryID changed from "+ prevProps.riskname + " to " +this.props.riskname)
            this.getRiskDetail();

            this.getTasks();
            this.getAssignee();
        }
        if (this.props !== prevProps) {
            this.setState({ value: 0 })
        }
    }
    getAssignee() {
        axios.get(config.assigneeList).then(res => {
            // let listOfAssignee = res.data
            // console.log("assignee");
            // console.log(listOfAssignee);
            this.setState({
                listOfAssignee: res.data
            });
        })
    }
    getRiskDetail() {
        if (this.props.riskname == null) {
            this.setState({

            });
        } else {
            console.log("riskname is not null")
            axios.get(config.rrattachment + '/' + this.props.riskname).then(res => {
                console.log("below is the res from list detail")
                console.log(res)
                this.setState({
                    riskExcelList:res.data
                });
                // console.log("attachments")
                // console.log(this.state.metaData.attachments)
            });
        }
    }

    getTasks() {
        if (this.props.queryID == null) {
            this.setState({
                tasksdata: []
            });
        } else {
            // console.log("axios request for logs");
            axios.get(config.rrattachment + '/' + this.props.queryID).then(res => {
                console.log("below is the res from tasks");
                console.log(res);
                this.setState({
                    tasksdata: res.data
                });
            });
        }
    }

    getTasksWithID = (ID) =>{

        console.log("now get task with query ID :" + ID)
        if (ID == null) {
            this.setState({
                tasksdata: []
            });
        } else {
            // console.log("axios request for logs");
            axios.get(config.alert + ID + "/tasks").then(res => {
                console.log("below is the res from tasks");
                console.log(res);
                this.setState({
                    tasksdata: res.data
                });
                this.forceUpdate();
            });
        }

        if (ID == null) {
            this.setState({
                logsdata: []
            });
        } else {
            // console.log("axios request for logs");
            axios.get(config.alert + ID + "/logs").then(res => {
                // console.log("below is the res from action logs");
                // console.log(res);
                this.setState({
                    logsdata: res.data.logs
                });
            });
        }


        if (ID == null) {
            this.setState({
                metaData: {
                    "routine": "",
                    "alert_ID": "",
                    "entity": "",
                    "owner_id": "",
                    "owner_name": "",
                    "status": "",
                    "created_date": "",
                    name: ""
                    //"outstanding_task_count": res.data.outstanding_task_count,
                },
                fields: [],
                data: []
            });
        } else {
            axios.get(config.alert + ID).then(res => {
                // console.log("below is the res from list detail")
                // console.log(res)
                this.setState({
                    metaData: {
                        "routine": res.data.routine,
                        "alert_ID": res.data.id,
                        "entity": res.data.entity,
                        "owner_id": res.data.owner,
                        "owner_name": res.data.owner_name,
                        "status": res.data.status,
                        "created_date": res.data.created_date,
                        "attachments": res.data.attachments,
                        name: res.data.name
                        //"outstanding_task_count": res.data.outstanding_task_count,
                    },
                    fields: res.data.detail.table_def,
                    data: res.data.detail.items,
                    queryID:this.props.queryID
                });
                // console.log("attachments")
                // console.log(this.state.metaData.attachments)
            });
        }
    };


    handleTaskSubmitUpdate = () => {
        console.log("get a task info update agian!!!!!!!");
        this.getTasks();
    };

    handleExpandClick = () => {
        this.setState(state => ({ expanded: !state.expanded }));
    };
    handleViewToggle = () => {
        this.setState(state => ({ actionView: this.state.actionView ? false : true }));
    };
    handleClickOpen = () => {
        this.setState({ open: true });
    };
    handleAssignmentClickOpen = () => {
        this.setState({ assignmentOpen: true });
    };
    handleTaskDialog = () => {
        this.setState({ taskDialogOpen: true });
        this.forceUpdate();
    };
    handleTaskDialogClose = () => {
        // console.log("set dialog state to false")
        this.setState({ taskDialogOpen: false });
    };
    handleTaskClickOpen = () => {

    };
    handleAlertActionCloseClose = () => {
        this.setState({ open: false });
        this.setState({ assignmentOpen: false });
    };

    handleAlertActionCloseSubmit = () => {

        let submitObj = {};
        submitObj.status = "Pending Approval For Closure";
        submitObj.comment = this.state.closureComment;
        submitObj.owner = this.state.metaData.owner_id;
        submitObj.reason = this.state.reason;
        //console.log("submit object:")
        //console.log(submitObj);
        console.log(submitObj.reason)
        console.log(submitObj.reason != "")
        if ( submitObj.reason != "") {
            axios.put(config.alert + this.props.queryID+"/", submitObj ).then(res=>{
                //console.log(res);
            }).catch(error => {console.log(error.response)})
            
            if ( this.state.attachment != null) {
                let formData = new FormData();
                let uploads = this.state.attachment;
                //console.log(uploads)
                formData.append("file", uploads);
                //console.log(formData)
                axios.post(config.attachment, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res=>{
                    //console.log(res);
                    var id = res.data.id
                    //console.log(id)
                    let fileObj = {};
                    fileObj.attached_content_type = "alert"
                    fileObj.attached_object_ID = this.props.queryID
                    //console.log(fileObj)
                
                    axios.put(config.attachment + "/" + id, fileObj).then(res=>{
                        //console.log(res);
                        this.getRiskDetail();
                    }).catch(error => {console.log(error.response)})
                }).catch(error => {console.log(error.response)})}

            this.setState({ open: false });
        }else{
            alert("please choose reason for closure")
        }

    };


    handleAlertCloseApprove = () => {
        let submitObj = {};
        submitObj.status = "Closed";
        submitObj.comment = this.state.approvalComment;
        submitObj.owner = this.state.metaData.owner_id;
        // console.log("submit object:")
        // console.log(submitObj);
        axios.put(config.alert + this.props.queryID+"/", submitObj ).then(res=>{
            console.log(res);
        }).catch(error => {console.log(error.response)})

        var formData = new FormData();
        var uploads = this.state.attachment;
        //console.log(uploads)
        formData.append("file", uploads);
        //console.log(formData)

        axios.post(config.attachment, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        }).then(res=>{
            //console.log(res);
            var id = res.data.id
            //console.log(id)
            let fileObj = {};
            fileObj.attached_content_type = "alert"
            fileObj.attached_object_ID = this.props.queryID
            //console.log(fileObj)
    
            axios.put(config.attachment + "/" + id, fileObj).then(res=>{
                //console.log(res);
                this.getRiskDetail()
            }).catch(error => {console.log(error.response)})
        }).catch(error => {console.log(error.response)})
        

        this.setState(state => ({ actionView: this.state.actionView ? false : true }));

    };

    handleAlertAssignment = () => {
        let submitObj = {};
        submitObj.status = this.state.metaData.status;
        submitObj.comment = this.state.assignComment;
        submitObj.owner = this.state.metaData.owner_id;
        submitObj.assigned_user_name = this.state.assignedUserName;
        // console.log("submit assigment object:");
        // console.log(submitObj);
        if(submitObj.assigned_user_name != ""){
            axios.put(config.alert + this.props.queryID+"/", submitObj ).then(res=>{
                console.log(res);
            }).catch(error => {console.log(error.response)})
            

            this.setState({ assignmentOpen: false });
        }else{
            alert("please choose assignee")
        }
    };

    handleAssigneeChange = (selectedOption) => {
        // this.setState({ selectedOption });
        console.log(`Option selected:`, selectedOption);
        if (selectedOption)
        {        
            // let name = selectedOption.label;
            // console.log(name)
            let value = selectedOption.value;

            // console.log(value)
            this.setState({
                assignedUserName:value
            });
        }
    }

    handleChange = (event, value) => {
        this.setState({ value });
    };
    handleCloseDialogChange =  event => {
        let reason = event.target.value;
        this.setState({ reason: reason });
    };
    handleChangeIndex = index => {
        this.setState({ value: index });
    };
    handleFileUpload = (e) => {
        let value = e.target.files[0];
        // console.log(e.target.files[0])
        // console.log(e.target.files)
        // console.log(value)
        // console.log(this.props.queryID)
        this.setState(state =>{this.state.attachment=value;});
    };

    handleDetailClick = (kri) => {
        this.setState({ kri: kri })
        this.setState({ value: 1 })
    };

    render() {
        //console.log(this.state.tasksdata)
        // console.log("in list detail render")
        // console.log(this.state.metaData)
        // console.log("the queryID of this listdetail is "+ this.props.queryID)
        // console.log("render with data ");
        // console.log(this.state.data);
        // console.log("data username : "+ this.state.metaData.owner_name+"    props username : "+ this.props.username)
        const { classes } = this.props;
        // console.log("pending tasks : "+ this.state.tasksdata)
        console.log('kri in RRDetail')
        console.log(this.props.kri== null ? 'not passed yet' : this.props.kri)
        const testEmails = ["yongyibian@kpmg.com", "elisa@kpmg.com", "yuri@kpmg.com", "jiajie@kpmg.com", "koonhan@kpmg.com"]

        const options = this.state.listOfAssignee ? this.state.listOfAssignee.map(user=>({
            value: user.username,
            label: user.username
        })) : undefined

        const header = ['Period', 'Status', 'Owner']

        const detailsView = (
            <Card className={classes.card}>
                <TaskDialog id={this.state.queryID} open={this.state.taskDialogOpen} close = {this.handleTaskDialogClose} users={this.state.listOfAssignee}/>
                <CardContent className={classes.content}>
                    {/*<RoutineDescriptionTable {...this.state} />*/}
                    {(this.props.kri == null || this.props.kri =='') ?
                        <Typography variant='h6'> Please select a kri reportng to continue </Typography>
                        : <DuplicateTxnTable
                            count={this.props.count == null ? 0 : (this.props.count + 1)}
                            username={this.props.username}
                            data={this.props.kri.detail}
                            header={header}
                            taskRefresh={this.getTasksWithID}
                            metadata = {this.state.metaData}
                            clickHandler = {this.handleDetailClick}
                        />}
                </CardContent>

            </Card>
        );
        const routineTabs = (
            <div style={{height:'100%'}}>
                <Tabs
                    className={classes.tab}
                    value={this.state.value}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.handleChange}
                    variant= "fullWidth"
                >
                    <Tab label="History" />
                    {(this.props.kri == null || this.props.kri == '') ? null : <Tab disabled={true} label='Enter Information' />}
                </Tabs>
                <Divider />
                {this.state.value == 0 ? detailsView : null}
                {this.state.value === 1 ? <TaskList
                    threshold={this.props.threshold}
                    submitUpdate = {this.handleTaskSubmitUpdate}
                    owner={this.state.metaData.owner_name == this.props.username}
                    kri={this.state.kri}
                    update={this.props.update}
                    users={this.state.listOfAssignee}/> : null}
                <Divider />
            </div>
        )
        return (
            <div style={{height:'100%'}}>
                {routineTabs}
            </div>
        );
    }
}

RecipeReviewCard.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RecipeReviewCard);


// WEBPACK FOOTER //
// ./src/components/KRI/KRIReportingDetail.js